import './mainLayout.scss';



import React from 'react';
//import SiteHeader from '../../../../components/Layout/header/SiteHeader';
import Layout from './Layout';
import Footer from './footer';
import SiteHeader from '../header/SiteHeader';

interface MainLayoutProps {
    children: any;
    bgColor?: string;
    config?: { mainPadding: string };
}

export default function (props: MainLayoutProps) {
    return (
        <>
            <SiteHeader />
            <Layout {...props} />
            <Footer />
        </>
    );
}